/**
 * Neutral toast that prefers `toast.info` and falls back to `toast.success`
 * when the toast API doesn't expose an info variant. Centralized so the
 * fallback lives in one place instead of being re-derived per call site.
 */
export function toastNotify(toast, payload) {
  const notify = toast.info ?? toast.success;
  notify(payload);
}

/** Mock UCP navigation until CT-4867 wires the real profile route. */
export function notifyUcpOpened(toast, t, profile) {
  toastNotify(toast, {
    title: t('continuation.ucpOpenedTitle'),
    message: t('continuation.ucpOpenedMessage', { profile }),
  });
}
